// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const KIMI_CODING_MODELS = {
	"k2p7": {
		id: "k2p7",
		name: "Kimi K2.7 Code",
		api: "anthropic-messages",
		provider: "kimi-coding",
		baseUrl: "https://api.kimi.com/coding",
		headers: {"User-Agent":"KimiCLI/1.5"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"k3": {
		id: "k3",
		name: "Kimi K3",
		api: "anthropic-messages",
		provider: "kimi-coding",
		baseUrl: "https://api.kimi.com/coding",
		headers: {"User-Agent":"KimiCLI/1.5"},
		compat: {"allowEmptySignature":true,"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":null,"medium":null,"high":null,"xhigh":null,"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"anthropic-messages">,
	"kimi-for-coding": {
		id: "kimi-for-coding",
		name: "Kimi For Coding",
		api: "anthropic-messages",
		provider: "kimi-coding",
		baseUrl: "https://api.kimi.com/coding",
		headers: {"User-Agent":"KimiCLI/1.5"},
		compat: {"allowEmptySignature":true,"forceAdaptiveThinking":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"kimi-for-coding-highspeed": {
		id: "kimi-for-coding-highspeed",
		name: "Kimi For Coding HighSpeed",
		api: "anthropic-messages",
		provider: "kimi-coding",
		baseUrl: "https://api.kimi.com/coding",
		headers: {"User-Agent":"KimiCLI/1.5"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
	"kimi-k2-thinking": {
		id: "kimi-k2-thinking",
		name: "Kimi K2 Thinking",
		api: "anthropic-messages",
		provider: "kimi-coding",
		baseUrl: "https://api.kimi.com/coding",
		headers: {"User-Agent":"KimiCLI/1.5"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0,
			output: 0,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 32768,
	} satisfies Model<"anthropic-messages">,
} as const;
